import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { State } from 'src/app/interfaces/state';

import { AddressForm } from './address-form';

export class ContactForm extends FormGroup<{
  id: FormControl<null | number>;
  email: FormControl<string | undefined>;
  firstName: FormControl<string | undefined>;
  lastName: FormControl<string | undefined>;
  isPrimary: FormControl<boolean>;
  jobTitle: FormControl<string | null>;
  phone1: FormControl<string | null>;
  phone2: FormControl<string | null>;
  ext: FormControl<string | null>;
  ext2: FormControl<string | null>;
  address: FormControl<string | undefined>;
  address2: FormControl<string | null>;
  city: FormControl<string | undefined>;
  state: FormControl<State | undefined>;
  zip: FormControl<string | undefined>;
  SiteId: FormControl<null | number>;
  CompanyId: FormControl<null | number>;
  VendorId: FormControl<null | number>;
  ExemptVendorId: FormControl<null | number>;
  ClientRegisteredVendorId: FormControl<null | number>;
  UserId: FormControl<null | number>;
  isArchived: FormControl<boolean>;
  isCompliance: FormControl<boolean>;
  isBid: FormControl<boolean>;
  isBilling: FormControl<boolean>;
  isPrimaryCompliance: FormControl<boolean>;
  isPrimaryBid: FormControl<boolean>;
  isPrimaryBilling: FormControl<boolean>;
  isContractVendor: FormControl<boolean>;
  isContractSite: FormControl<boolean>;
  ContractId: FormControl<null | number>;
  invitationSendDate: FormControl<Date | null>;

  StreetAddress?: AddressForm;
  MailingAddress?: AddressForm;
  Addresses?: FormArray<AddressForm>;
}> {
  constructor() {
    const StreetAddress = new AddressForm();
    const MailingAddress = new AddressForm();

    StreetAddress.controls['isStreet'].patchValue(true);
    MailingAddress.controls['isMailing'].patchValue(true);

    super({
      id: new FormControl<null | number>(null),
      email: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      firstName: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      lastName: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isPrimary: new FormControl<boolean>(false, { nonNullable: true }),
      jobTitle: new FormControl<string | null>(null),
      phone1: new FormControl<string | null>(null, {
        validators: [Validators.required]
      }),
      phone2: new FormControl<string | null>(null),
      ext: new FormControl<string | null>(null),
      ext2: new FormControl<string | null>(null),
      address: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      address2: new FormControl<string | null>(null),
      city: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      state: new FormControl<State | undefined>(undefined, {
        nonNullable: true
      }),
      zip: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      SiteId: new FormControl<null | number>(null),
      CompanyId: new FormControl<null | number>(null),
      VendorId: new FormControl<null | number>(null),
      ExemptVendorId: new FormControl<null | number>(null),
      ClientRegisteredVendorId: new FormControl<null | number>(null),
      UserId: new FormControl<null | number>(null),
      isArchived: new FormControl<boolean>(false, { nonNullable: true }),
      isCompliance: new FormControl<boolean>(false, { nonNullable: true }),
      isBid: new FormControl<boolean>(false, { nonNullable: true }),
      isBilling: new FormControl<boolean>(false, { nonNullable: true }),
      isPrimaryCompliance: new FormControl<boolean>(false, {
        nonNullable: true
      }),
      isPrimaryBid: new FormControl<boolean>(false, { nonNullable: true }),
      isPrimaryBilling: new FormControl<boolean>(false, { nonNullable: true }),
      isContractVendor: new FormControl<boolean>(false, { nonNullable: true }),
      isContractSite: new FormControl<boolean>(false, { nonNullable: true }),
      ContractId: new FormControl<null | number>(null),
      invitationSendDate: new FormControl<Date | null>(null),

      StreetAddress,
      MailingAddress
    });
  }
}
